/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Button } from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/redirecttoversiontwo/redirecttoversiontwo_styles';



/* ========== ~~~~~~~~~~ CTA : REDIRECT TO PUBLISHER PORTAL v2 BUTTON ~~~~~~~~~~ ========== */
const RedirectToVersionTwo = (props) => {
    const redirectToPubPortalV2 = () => {
        window.open(`https://publisher-portal.${url.baseURL}`, '_self')
    }
    return (
        <Button
            type={'custom'}
            handleClick={redirectToPubPortalV2}
            variant={`primary`}
            name={`redirect-to-version-two`}
            text={'Try the new beta portal'}
            klass={props.classes.redirecttoversiontwo}
        />
    );
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(RedirectToVersionTwo);
